@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.helper-text {
  display: flex;
  align-items: center;
  min-height: 24px;
  padding: 4px;
  border-radius: 2px;
  font-size: 12px;
  line-height: 16px;

  &.error {
    background: @inline-message--error--background-color;
    & > .icon {
      color: @inline-message--error--text-color;
    }
  }
  &.warning {
    background: @inline-message--warning--background-color;
    & > .icon {
      color: @inline-message--warning--text-color;
    }
  }
  &.info {
    background: @inline-message--info--background-color;
    & > .icon {
      color: @inline-message--info--text-color;
    }
  }
  &.sublabel {
    color: @inline-message--sublabel--text-color;
    padding: 4px 4px 4px 0;
  }

  .icon {
    display: flex;
    align-items: center;
    width: 16px;
    height: 16px;
    margin-right: 2px;
  }

  .text {
    width: 100%;
    font-size: 12px;
    padding-left: 4px;
  }
}
